import request from "@/utils/request"
import type { AxiosPromise } from "axios"
import type { CodeCheckResultDto, LoginDataDto } from "./types"

/**
 * 执行登录
 * @param data {LoginForm}
 * @returns AxiosPromise<TokenResult>
 */
export function loginUsername(
    data: LoginDataDto | { [key: string]: string },
    tenantId?: number,
    tenantCode?: string
): AxiosPromise<CodeCheckResultDto> {
    return request.post("/auth/oauth/token", data, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            // Authorization: "Basic " + window.btoa("zbcloud:zbcloud"),
            "TENANT-ID": tenantId,
            "TENANT-CODE": tenantCode,
            "SERVICE-CODE": process.env.VUE_APP_SERVICE_CODE
        }
    })
}
/**
 * 验证token
 * @returns
 */
export function checkToken() {
    return request({
        url: "/auth/oauth/check_token",
        method: "get"
    })
}

/**
 * 退出登录
 */
export function logout(): AxiosPromise {
    return request({
        url: "/auth/token/logout",
        method: "DELETE"
    })
}
